<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :is-show-search-input="true"
    :push-list="RouteConfig.courseTagList.push"
    search-placeholder="输入名称进行搜索"
  >
    <v-column-time/>
    <v-column-time value="修改时间" field="update_time" sortable=""/>
    <el-table-column label="标签 ID" width="80" prop="id"/>
    <el-table-column label="标签名称" width="300" prop="course_tag_name"/>

    <el-table-column label="标签封面">
      <template v-slot="{ row }">
        <v-img :value="row.cover" class="table-cover-video"/>
      </template>
    </el-table-column>

    <el-table-column label="操作" width="320px">
      <template v-slot="{ row }">
        <v-list-button
          name="小程序码"
          icon="mini-app-qr-code"
          size="large"
          @click="getQrCode(row.id)"
          :is-loading="isGetting[row.id]"
        />
        <v-list-button name="修改标签" size="large" :to="RouteConfig.courseTagEdit.to(row.id)"/>
        <v-popover>
          <v-popover-item
            icon="bin"
            name="删除标签"
            @click="handleDelete(row.id)"
            :is-loading="isDeleting[row.id]"
            message="确认要删除该标签吗？"
          />
        </v-popover>
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`card-ticket-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>修改时间</span>
              <span>{{ v.update_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>标签 ID</span>
              <span>{{ v.id }}</span>
            </div>

            <div class="list-item-detail">
              <span>标签名称</span>
              <span>{{ v.course_tag_name }}</span>
            </div>

            <div class="list-item-detail">
              <span>标签封面</span>
              <v-img :value="v.cover" class="table-cover-video"/>
            </div>

            <div class="list-item-button">
              <v-list-button
                name="小程序码"
                icon="mini-app-qr-code"
                size="large"
                @click="getQrCode(v.id)"
                :is-loading="isGetting[v.id]"
              />
              <v-list-button name="修改标签" size="large" :to="RouteConfig.courseTagEdit.to(v.id)"/>
              <v-popover>
                <v-popover-item
                  icon="bin"
                  name="删除标签"
                  @click="handleDelete(v.id)"
                  :is-loading="isDeleting[v.id]"
                  message="确认要删除该标签吗？"
                />
              </v-popover>
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
  import RouteConfig from '@/router/config';
  import { index, destroy, getQrCode } from '@/api/course-tag';
  import { getLegalQueryList } from "@/utils/formats";

  export default {
    name: RouteConfig.courseTagList.name,
    data: () => ({
      RouteConfig,
      count: 0,
      list: [],
      queryList: {
        keyword: '',
        is_asc: 0,
        page: 1,
        size: 10,
      },
      isLoading: false,
      isDeleting: {},
      isGetting: {},
    }),
    watch: {
      '$route'(to) {
        this.load(to);
      },
    },
    beforeMount() {
      this.load();
    },
    methods: {
      async load(route = this.$route, next) {
        const { queryList } = this;
        getLegalQueryList(queryList, route.query);

        this.isLoading = true;
        const { isError, data } = await index(queryList);
        this.isLoading = false;
        if (isError) return;

        this.count = data.count;
        this.list = data.list;
        if (next) next();
      },
      async handleDelete(id) {
        if (!id) return this.$message.warning('缺少标签 ID，无法删除该标签！');
        if (this.isDeleting[id]) return;

        this.$set(this.isDeleting, id, true);
        const { isError } = await destroy(id);
        this.$set(this.isDeleting, id, false);

        if (!isError) this.load();
      },
      async getQrCode(id) {
        if (this.isGetting[id]) return;

        this.$set(this.isGetting, id, true);
        const { isError, data } = await getQrCode(id);
        this.$set(this.isGetting, id, false);
        if (isError) return;

        data.qr_code && window.open(data.qr_code);
      },
    },
  };
</script>
